import { styled as styledMUI } from '@material-ui/styles'

import InfiniteScroll from 'react-infinite-scroller'
import UBox from 'src/components/ui/Ubox'

export const Board = styledMUI(
  ({ esconderSetaAvancar, esconderSetaVoltar, ...rest }) => <UBox {...rest} />
)(() => ({
  margin: 0,
  padding: 0,
  backgroundColor: 'rgb(65,36,93)',
  background:
    'linear-gradient(166deg, #455880 0%, rgb(108 108 185) 30%, rgb(94, 185, 167) 100%)',
  borderRadius: 0,
  overflowX: 'hidden',
  scrollbarColor: 'rgba(212, 212, 212, 0.81) rgba(40,40,40,0.1)',
  scrollbarWidth: 'thin',
  position: 'relative',
  '&:hover .ear-left-kanban': {
    opacity: props => (props.esconderSetaVoltar ? 0 : 1)
  },
  '&:hover .ear-right-kanban': {
    opacity: props => (props.esconderSetaAvancar ? 0 : 1)
  }
}))

export const Container = styledMUI(UBox)(() => ({
  display: 'flex',
  overflow: 'auto',
  padding: '8px',
  width: '100%',
  height: '90vh ',
  overflowX: 'scroll'
}))

export const EarLeft = styledMUI(UBox)(() => ({
  background: 'url(/image/kanban/arrow-left.svg) center left no-repeat',
  left: 0,
  display: 'block',
  // backgroundColor: 'red',
  width: '50px',
  height: '100%',
  position: 'absolute',
  zIndex: 99,

  opacity: 0,
  // opacity: 1,
  // pointerEvents: 'none',
  '-webkit-transition': '.2s',
  transition: '.2s'
  // top: 0,
  // bottom: 0,
  // left: '-50px',
}))

export const EarRight = styledMUI(UBox)(() => ({
  background: 'url(/image/kanban/arrow-right.svg) center right no-repeat',
  right: 0,
  // display: 'block',
  // backgroundColor: 'red',
  width: '50px',
  height: '100%',
  position: 'absolute',
  zIndex: 99,
  opacity: 0,
  // opacity: 1,

  // pointerEvents: 'none',
  '-webkit-transition': '.2s',
  transition: '.2s'
}))

export const Coluna = styledMUI(UBox)(() => ({
  padding: '4px',
  width: '300px',
  minWidth: '300px',
  height: '100%',
  borderRight: '1px dashed #ddd'
}))

export const InfiniteScrollColuna = styledMUI(({ isDraggingOver, ...rest }) => (
  <InfiniteScroll {...rest} />
))({
  backgroundColor: props =>
    props.isDraggingOver ? 'rgba(200,200,200,0.4)' : 'rgba(200,200,200,0)',
  borderRadius: '4px',
  transition: '0.3s',
  //   '&:has(> .card-kanban)': {
  //     paddingRight: '15px'
  //   },

  overflow: 'auto',
  //   overflow: 'hidden',
  '&:hover': {
    paddingRight: '0px'
  },
  height: 'calc(90vh - 80px)'
})
